export default __webpack_public_path__ + "static/bootstrap-4430123dc30a1156f0a17fc32aa17617.png";